export const states = [
    { abbr: "AL", state: "Alabama" },
    { abbr: "AK", state: "Alaska" },
    { abbr: "AZ", state: "Arizona" },
    { abbr: "AR", state: "Arkansas" },
    { abbr: "CA", state: "California" },
    { abbr: "CO", state: "Colorado" },
    { abbr: "CT", state: "Connecticut" },
    { abbr: "DE", state: "Delaware" },
    { abbr: "FL", state: "Florida" },
    { abbr: "GA", state: "Georgia" },
    { abbr: "HI", state: "Hawaii" },
    { abbr: "ID", state: "Idaho" },
    { abbr: "IL", state: "Illinois" },
    { abbr: "IN", state: "Indiana" },
    { abbr: "IA", state: "Iowa" },
    { abbr: "KS", state: "Kansas" },
    { abbr: "KY", state: "Kentucky" },
    { abbr: "LA", state: "Louisiana" },
    { abbr: "ME", state: "Maine" },
    { abbr: "MD", state: "Maryland" },
    { abbr: "MA", state: "Massachusetts" },
    { abbr: "MI", state: "Michigan" },
    { abbr: "MN", state: "Minnesota" },
    { abbr: "MS", state: "Mississippi" },
    { abbr: "MO", state: "Missouri" },
    { abbr: "MT", state: "Montana" },
    { abbr: "NE", state: "Nebraska" },
    { abbr: "NV", state: "Nevada" },
    { abbr: "NH", state: "New Hampshire" },
    { abbr: "NJ", state: "New Jersey" },
    { abbr: "NM", state: "New Mexico" },
    { abbr: "NY", state: "New York" },
    { abbr: "NC", state: "North Carolina" },
    { abbr: "ND", state: "North Dakota" },
    { abbr: "OH", state: "Ohio" },
    { abbr: "OK", state: "Oklahoma" },
    { abbr: "OR", state: "Oregon" },
    { abbr: "PA", state: "Pennsylvania" },
    { abbr: "RI", state: "Rhode Island" },
    { abbr: "SC", state: "South Carolina" },
    { abbr: "SD", state: "South Dakota" },
    { abbr: "TN", state: "Tennessee" },
    { abbr: "TX", state: "Texas" },
    { abbr: "UT", state: "Utah" },
    { abbr: "VT", state: "Vermont" },
    { abbr: "VA", state: "Virginia" },
    { abbr: "WA", state: "Washington" },
    { abbr: "WV", state: "West Virgina" },
    { abbr: "WI", state: "Wisconsin" },
    { abbr: "WY", state: "Wyoming" },
  ];

export const typeaheaddata=[
  {
    title:"Basic Demo",
    id:"the-basics",
    subtitle:"This is the simple demo for Typeahead."
  },
  {
    title:"Prefetch",
    id:"prefetch",
    subtitle:"Prefetched data is fetched and processed on initialization"
  },
  {
    title:"Bloodhound (Suggestion Engine)",
    id:"bloodhound",
    subtitle:"Bloodhound offers advanced functionalities such as prefetching and backfilling with remote data."
  },
  {
    title:"Remote",
    id:"remote",
    subtitle:"Remote data is only used when the data provided by local and prefetch is insufficient"
  },
  {
    title:"Custom Templates",
    id:"custom-templates",
    subtitle:"Custom templates give you full control over how suggestions get rendered"
  },
  {
    title:"Multiple Sections with Headers",
    id:"multiple-datasets",
    subtitle:"Two datasets that are prefetched, stored, and searched on the client. Highlighting is enabled."
  },
  {
    title:"Default Suggestions",
    id:"default-suggestions",
    subtitle:"Default suggestions can be shown for empty queries."
  },
  {
    title:"Scrollable Dropdown Menu",
    id:"scrollable-dropdown-menu",
    subtitle:"Dataset shows in scrollable dropdown menu."
  }
]

export const disableswitch =[
  {
    class:"",
    title:"Disabled State"
  },
  {
    class:"icon-state",
    title:"Disabled With Icon"
  },
]

export const switchicon = [
  {
    class:"",
    id:1,
    title:"Default Switch"
  },
  {
    id:2,
    class:"",
    title:"Unhecked Switch"
  },
  {
    id:1,
    class:"icon-state",
    title:"With Icon"
  },
  {
    id:2,
    class:"icon-state",
    title:"Unhecked With Icon"
  }
]
export const outlinedata =[
  {
    name:"Primary Color",
    color:"primary"
  },
  {
    name:"Secondary Color",
    color:"secondary"
  },
  {
    name:"Success Color",
    color:"success"
  },
  {
    name:"Info Color",
    color:"info"
  },
  {
    name:"Warning Color",
    color:"warning"
  },
  {
    name:"Danger Color",
    color:"danger"
  }
]
export const switchdata = [
  {
    name:"Primary Switch",
    color:"primary"
  },
  {
    name:"Secondary Switch",
    color:"secondary",
  },
  {
    name:"Success Switch",
    color:"success",
  },
  {
    name:"Info Switch",
    color:"info"
  },
  {
    name:"Warning Switch",
    color:"warning"
  },
  {
    name:"Danger Switch",
    color:"danger"
  }
]
export const sizingswitch = [
  {
    id:1,
    class:"switch-lg",
    name:"Large Size"
  },
  {
    id:2,
    class:"switch-lg",
    name:"Large Unchecked"
  },
  {
    id:1,
    class:"",
    name:"Normal Size"
  },
  {
    id:2,
    class:"",
    name:"Normal Unhecked"
  },
  {
    id:1,
    class:"switch-sm",
    name:"Small Size"
  },
  {
    id:2,
    class:"switch-sm",
    name:"Small Size Unhecked"
  }
]
export const siziswitchdata =[
  {
    name:"Primary Color (Disabled)",
    color:"primary",
    class:"switch-lg",
    value:true
  },
  {
    name:"Secondary Color",
    color:"secondary",
    class:"switch-lg",
  },
  {
    name:"Success Color",
    color:"success"
  },
  {
    name:"Info Color",
    color:"info"
  },
  {
    name:"Warning Color",
    color:"warning",
    class:"switch-sm",
  },
  {
    name:"Danger Color",
    color:"danger",
    class:"switch-sm",
  }
]

export const fullcolorselect = [
  {
    title :"Primary Select",
    class:"primary-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Secondary Select",
    class:"secondary-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Success Select",
    class:"success-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Info Select",
    class:"info-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Warning Select",
    class:"warning-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Danger Select",
    class:"danger-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Inverse Select",
    class:"inverse-fill",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  }
]

export const outlineselect = [
  {
    title :"Primary Select",
    class:"primary",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Secondary Select",
    class:"secondary",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Success Select",
    class:"success",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Info Select",
    class:"info",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Warning Select",
    class:"warning",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Danger Select",
    class:"danger",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  },
  {
    title :"Inverse Select",
    class:"inverse",
    value:"Select One Value Only",
    options : [
      {
        opt1:"Select One Value Only"
      },
      {
        opt1:"Type 2"
      },
      {
        opt1:"Type 3"
      },
      {
        opt1:"Type 4"
      },
      {
        opt1:"Type 5"
      },
      {
        opt1:"Type 6"
      },
      {
        opt1:"Type 7"
      },
      {
        opt1:"Type 8"
      }
    ]
  }
]

export const optdata=["Alabama","Wyoming","Coming","Hanry Die","John Doe"
]

export const textboxdata = ["Smith","Peter","James","Hanry Die","John Doe","Harry Poter"]